import * as React from 'react';

type ProjectLeftPanelAddBtnProps = {
    title: string,
    onClick: () => void,
    display: boolean,
    className?: string
}

function ProjectLeftPanelAddBtn({ title, onClick, display, className }: ProjectLeftPanelAddBtnProps) {
    if (display) {
        return (
            <div className={`ProjectLeftPanel__add-btn ${className} action-btn flexible dark-with-blue-border`}
                onClick={onClick}>
                <i className="icon icon-alan-plus-stroked" />
                {title}
            </div>
        );
    }
    return null;
}

export default ProjectLeftPanelAddBtn;
